import { useReducer, useCallback } from "react";
import ImageUploader from "../services/imageUploader";

const imageUploader = new ImageUploader();

// 액션 타입 정의

const IMAGE_UPLOAD_START = "IMAGE_UPLOAD_START";
const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
const IMAGE_UPLOAD_ERROR = "IMAGE_UPLOAD_ERROR";

// 액션 생성 함수

const imageUploadStart = () => ({ type: IMAGE_UPLOAD_START });
const imageUploadSuccess = (data) => ({ type: IMAGE_UPLOAD_SUCCESS, data });
const imageUploadError = (error) => ({ type: IMAGE_UPLOAD_ERROR, error });

// 리듀서 함수

const imageFileReducer = (prevState = initialState, action) => {
  switch (action.type) {
    case IMAGE_UPLOAD_START:
      return { ...prevState, loading: true };

    case IMAGE_UPLOAD_SUCCESS:
      return { ...prevState, loading: false, data: action.data };

    case IMAGE_UPLOAD_ERROR:
      return { ...prevState, loading: false, error: action.error };

    default:
      return prevState;
  }
};

// 초기 값

const initialState = {
  loading: false,
  data: null,
  error: null,
};

// 전역 말고 지역 상태를 useReducer로 관리하고 내보냄
const useFileUpload = () => {
  const [state, dispatch] = useReducer(imageFileReducer, initialState);

  const postData = useCallback(async (file) => {
    dispatch(imageUploadStart());
    try {
      const response = await imageUploader.upload(file);
      const result = {
        name: response.original_filename,
        url: response.secure_url,
      };
      dispatch(imageUploadSuccess(result));
    } catch (error) {
      dispatch(imageUploadError());
    }
  }, []);

  return [state, postData];
};

export default useFileUpload;
